import { ItemType } from '@vista-digital/ocapi-types/v1';
import { runInAction } from 'mobx';
export const updateInProgressItemIsValid = (inProgressItem) => {
    switch (inProgressItem.type) {
        case ItemType.Normal:
            return updateInProgressNormalItemIsValid(inProgressItem);
        case ItemType.ParentSales:
            return updateInProgressParentSalesItemIsValid(inProgressItem);
        default:
            throw 'Unsupported item type';
    }
};
const updateInProgressNormalItemIsValid = (inProgressItem) => {
    const valid = inProgressItem.modifierGroups.every(inProgressItemModifierGroupIsValid);
    runInAction(() => (inProgressItem.isValid = valid));
};
/**
 * Returns whether the item modifier group has been fulfilled based on the currently selected modifiers.
 */
const inProgressItemModifierGroupIsValid = (itemModifierGroup) => {
    return itemModifierGroup.minimumReached && !itemModifierGroup.maximumExceeded;
};
const updateInProgressParentSalesItemIsValid = (inProgressItem) => {
    if (!inProgressItem.selectedInProgressItems) {
        runInAction(() => (inProgressItem.isValid = false));
        return;
    }
    const selectedInProgressItems = Object.values(inProgressItem.selectedInProgressItems);
    selectedInProgressItems.forEach(option => {
        updateInProgressItemIsValid(option.item);
    });
    const invalidOption = selectedInProgressItems.find(option => !option.item.isValid);
    const totalItemSelectionCount = selectedInProgressItems.reduce((totalCount, selectedInProgressItem) => {
        totalCount += selectedInProgressItem.quantity;
        return totalCount;
    }, 0);
    runInAction(() => {
        inProgressItem.isValid = totalItemSelectionCount === 0 || invalidOption ? false : true;
    });
};
